const pagerNextIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10">
      <path fill="#979797" d="M169,20.5 C168.809155,20.5 168.618309,20.4364214 168.472939,20.3099131 L164,16.4173479 L165.054123,15.5 L169,18.9338913 L172.945877,15.5 L174,16.4173479 L169.527061,20.3099131 C169.381691,20.4364214 169.190845,20.5 169,20.5 Z" transform="matrix(0 1 1 0 -15 -164)"/>
    </svg>
`;

export default pagerNextIcon;
